// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2goKU","label":"Section_label__10NTz","contentWrap":"Section_contentWrap__3-Snm","footer":"Section_footer__1vF8E","footerInner":"Section_footerInner__2zxqr"};